import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import '../Customize_Css/ViewVendor.css';
import '../Customize_Css/Banners.css';
import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrashAlt, FaFileExport, FaEdit, FaSearch, FaEye, FaTag } from 'react-icons/fa';
import eye from '../Icons/Eye.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as XLSX from 'xlsx';

const formatDate = (dateString) => {
  const options = { day: '2-digit', month: 'long', year: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-GB', options).replace(/ /g, '-');
};

const ViewOffers = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const AuthorizationToken = localStorage.getItem('token');
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);

  useEffect(() => {
    const fetchOffers = async () => {
      if (!epicxTenantId) {
        console.error('Tenant ID is not provided');
        return;
      }
      try {
        const response = await fetch(`${BASE_URL}/offers/api/offers/${epicxTenantId}`,
          {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
              },
            }
        );
        if (!response.ok) throw new Error('Network response was not ok');
        const offers = await response.json();
        setOriginalData(offers);
        setData(offers);
      } catch (error) {
        console.error('Error fetching offers:', error);
        toast.error(`Error fetching offers: ${error.message}`);
      }
    };
    fetchOffers();
  }, []);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setData((prevData) =>
      [...prevData].sort((a, b) => {
        if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
        if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
        return 0;
      })
    );
  };

  const handleSearch = (value) => {
    setSearchTerm(value.toLowerCase());
    if (value.trim() === '') {
      setData(originalData);
    } else {
      const filteredData = originalData.filter((item) =>
        Object.keys(item).some((key) =>
          item[key]?.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
      setData(filteredData);
    }
    setCurrentPage(1);
  };

  const handleSelectAll = () => {
    if (selectedItems.length === data.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(data.map((item) => item._id));
    }
  };

  const handleSelectItem = (_id) => {
    if (selectedItems.includes(_id)) {
      setSelectedItems(selectedItems.filter((item) => item !== _id));
    } else {
      setSelectedItems([...selectedItems, _id]);
    }
  };

  const handleDelete = async () => {
    if (selectedItems.length === 0) {
      toast.warn('No items selected to delete');
      return;
    }
    const confirmed = window.confirm('Are you sure you want to delete the selected items?');
    if (!confirmed) return;
    try {
      for (const itemId of selectedItems) {
        const response = await axios.put(`${BASE_URL}/offers/api/offers/${epicxTenantId}/delete/${itemId}`,
          {}, 
          {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
              },
            }
        );
        console.log(`Item with id ${itemId} deleted`, response);
      }
      setData(data.filter((item) => !selectedItems.includes(item._id)));
      setSelectedItems([]);
      toast.success('Selected items deleted successfully!');
    } catch (error) {
      console.error('Error deleting items:', error);
      toast.error('Error deleting items. Please try again.');
    }
  };

  const handleEdit = () => {
    if (selectedItems.length === 1) {
      const [selectedId] = selectedItems;
      navigate(`/updateOffers/${selectedId}`);
    } else {
      toast.error('Please select exactly one offer to edit.');
    }
  };

  const handleExport = () => {
    const dataToExport = selectedItems.length > 0
      ? data.filter((item) => selectedItems.includes(item._id))
      : data;
    const exportData = dataToExport.map((item) => ({
      offerId: item.offerId,
      offerTitle: item.offerTitle,
      productVendorName: item.productVendorName,
      offerType: item.offerType,
      offerCode: item.offerCode,
      discountValue: item.discountValue,
      minimumPurchaseAmount: item.minimumPurchaseAmount,
      maximumDiscountAmount: item.maximumDiscountAmount,
      applicableProducts: item.applicableProducts,
      categories: item.categories,
      eligibleUsers: item.eligibleUsers,
      startDate: item.startDate,
      endDate: item.endDate,
      isActive: item.isActive,
      usageLimit: item.usageLimit,
      offerDescription: item.offerDescription,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Offers');
    XLSX.writeFile(wb, 'Offers_data.xlsx');
  };

  const handleViewMore = (offer) => {
    setSelectedOffer(offer);
    setShowDetailsModal(true);
  };

  const handleCloseDetailsModal = () => {
    setShowDetailsModal(false);
    setSelectedOffer(null);
  };

  const handleCloseModal = () => setShowModal(false);
  const handleSelect = (vendor) => {
    setSelectedVendors((prev) =>
      prev.includes(vendor) ? prev.filter((item) => item !== vendor) : [...prev, vendor]
    );
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  return (
    <>
      <Sidebar />
      <div className="vendors-page">
        <div>
          <header className="vendors-hero">
            <div>
              <p className="vendors-kicker">Sales</p>
              <h1>Offer List</h1>
              <p>Browse, find, and manage store offers.</p>
            </div>
            <button className="vendors-primary-btn" onClick={() => navigate('/addoffer')}>
              <FaPlus /> Add Offer
            </button>
          </header>
          <section className="vendors-toolbar" aria-label="Offer search and actions">
            <div className="vendors-search">
              <FaSearch aria-hidden="true" />
              <input
                type="text"
                className="form-control"
                placeholder="Search offers..."
                aria-label="Search offers"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <Dropdown>
              <Dropdown.Toggle className="vendors-action-btn">
                Action
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleDelete} disabled={selectedItems.length === 0}>
                  <FaTrashAlt className="me-2" /> Delete
                </Dropdown.Item>
                <Dropdown.Item onClick={handleEdit} disabled={selectedItems.length !== 1}>
                  <FaEdit className="me-2" /> Edit
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExport}>
                  <FaFileExport className="me-2" /> Export
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </section>
          <div className="vendors-card">
            <div className="vendors-card-head">
              <div>
                <h2>All Offers</h2>
                <p>Select an offer to edit, delete, or view full details.</p>
              </div>
              <span className="vendors-count">
                <FaTag aria-hidden="true" />
                {data.length} {data.length === 1 ? 'offer' : 'offers'}
              </span>
            </div>
            <div className="vendors-card-body">
              <div className="vendors-table-wrap">
                <table className="vendors-table">
                  <thead>
                    <tr>
                      <th className="vendors-check-cell">
                        <input
                          className="vendors-checkbox"
                          type="checkbox"
                          aria-label="Select all offers"
                          checked={selectedItems.length === data.length}
                          onChange={handleSelectAll}
                        />
                      </th>
                      {[
                        ['offerId', 'Offer Id'],
                        ['offerTitle', 'Offer Title'],
                        ['productVendorName', 'Product Vendor Name'],
                        ['offerCode', 'Offer Code'],
                        ['discountValue', 'Discount Value'],
                        ['applicableProducts', 'Applicable Products'],
                        ['status', 'Status'],
                        ['startDate', 'Start Date'],
                        ['endDate', 'End Date'],
                      ].map(([key, label]) => (
                        <th key={key} className={key === 'offerTitle' ? 'vendors-sticky-name' : undefined} onClick={() => handleSort(key)}>
                          {label}
                          {sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                        </th>
                      ))}
                      <th className="vendors-action-cell">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? currentData.map((item) => (
                      <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                        <td className="vendors-check-cell">
                          <input
                            className="vendors-checkbox"
                            type="checkbox"
                            aria-label={`Select ${item.offerTitle}`}
                            checked={selectedItems.includes(item._id)}
                            onChange={() => handleSelectItem(item._id)}
                          />
                        </td>
                        <td>{item.offerId}</td>
                        <td className="vendors-sticky-name"><span className="vendor-name">{item.offerTitle}</span></td>
                        <td>{item.productVendorName}</td>
                        <td><span className="banner-chip">{item.offerCode}</span></td>
                        <td>{item.discountValue}</td>
                        <td>{Array.isArray(item.applicableProducts) ? item.applicableProducts.join(', ') : item.applicableProducts}</td>
                        <td><span className="banner-chip">{item.isActive ? 'Active' : 'Inactive'}</span></td>
                        <td>{formatDate(item.startDate)}</td>
                        <td>{formatDate(item.endDate)}</td>
                        <td className="vendors-action-cell">
                          <button type="button" className="vendors-view-btn" onClick={() => handleViewMore(item)}>
                            <FaEye aria-hidden="true" /> View More
                          </button>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="11">
                          <div className="vendors-empty">
                            <span><FaTag aria-hidden="true" /></span>
                            <h3>No offers found</h3>
                            <p>Try another search or add a new offer.</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="vendors-card-footer">
              <span className="vendors-page-summary">
                {data.length > 0
                  ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, data.length)} of ${data.length}`
                  : 'Showing 0 offers'}
              </span>
              <div className="vendors-pagination">
                <nav>
                  <ul className="pagination mb-0" aria-label="Offers pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link btn-sm" onClick={() => setCurrentPage(1)} aria-label="First page">&laquo;</button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link btn-sm" onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} aria-label="Previous page">&lt;</button>
                    </li>
                    <li className="page-item active">
                      <button className="page-link btn-sm" aria-current="page">{currentPage}</button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link btn-sm" onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} aria-label="Next page">&gt;</button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link btn-sm" onClick={() => setCurrentPage(totalPages)} aria-label="Last page">&raquo;</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <Modal show={showDetailsModal} onHide={handleCloseDetailsModal} size="lg" centered dialogClassName="vendor-details-modal">
            <Modal.Header closeButton>
              <Modal.Title>{selectedOffer?.offerTitle || 'Offer Details'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedOffer && (
                <div className="vendor-details-content">
                  <div className="vendor-details-title">
                    {selectedOffer.offerUpload ? (
                      <img className="vendor-details-photo" src={selectedOffer.offerUpload} alt={selectedOffer.offerTitle || 'Offer'} />
                    ) : (
                      <span><FaTag aria-hidden="true" /></span>
                    )}
                    <div>
                      <small>Offer</small>
                      <h3>{selectedOffer.offerTitle}</h3>
                      <p>{selectedOffer.isActive ? 'Active' : 'Inactive'}</p>
                    </div>
                  </div>
                  <div className="vendor-details-grid">
                    {selectedOffer.offerId && <div><span>Offer ID</span><strong>{selectedOffer.offerId}</strong></div>}
                    {selectedOffer.productVendorName && (
                      <div><span>Vendor</span><strong>{selectedOffer.productVendorName}{selectedOffer.productVendorId ? ` (ID: ${selectedOffer.productVendorId})` : ''}</strong></div>
                    )}
                    {selectedOffer.offerType && <div><span>Offer Type</span><strong>{selectedOffer.offerType}</strong></div>}
                    {selectedOffer.offerCode && <div><span>Offer Code</span><strong>{selectedOffer.offerCode}</strong></div>}
                    {selectedOffer.discountValue && <div><span>Discount Value</span><strong>{selectedOffer.discountValue}</strong></div>}
                    {selectedOffer.minimumPurchaseAmount && <div><span>Min Purchase</span><strong>{selectedOffer.minimumPurchaseAmount}</strong></div>}
                    {selectedOffer.maximumDiscountAmount && <div><span>Max Discount</span><strong>{selectedOffer.maximumDiscountAmount}</strong></div>}
                    {selectedOffer.usageLimit && <div><span>Usage Limit</span><strong>{selectedOffer.usageLimit}</strong></div>}
                    {selectedOffer.applicableProducts && selectedOffer.applicableProducts.length > 0 && (
                      <div className="details-wide"><span>Applicable Products</span><strong>{Array.isArray(selectedOffer.applicableProducts) ? selectedOffer.applicableProducts.join(', ') : selectedOffer.applicableProducts}</strong></div>
                    )}
                    {selectedOffer.categories && selectedOffer.categories.length > 0 && (
                      <div className="details-wide"><span>Categories</span><strong>{Array.isArray(selectedOffer.categories) ? selectedOffer.categories.join(', ') : selectedOffer.categories}</strong></div>
                    )}
                    {selectedOffer.eligibleUsers && <div><span>Eligible Users</span><strong>{selectedOffer.eligibleUsers}</strong></div>}
                    {selectedOffer.startDate && <div><span>Start Date</span><strong>{formatDate(selectedOffer.startDate)}</strong></div>}
                    {selectedOffer.endDate && <div><span>End Date</span><strong>{formatDate(selectedOffer.endDate)}</strong></div>}
                    {selectedOffer.offerDescription && <div className="details-wide"><span>Description</span><strong>{selectedOffer.offerDescription}</strong></div>}
                    {selectedOffer.isAutoApply !== undefined && <div><span>Auto Apply</span><strong>{selectedOffer.isAutoApply ? 'Yes' : 'No'}</strong></div>}
                    {selectedOffer.isFirstOrderOnly !== undefined && <div><span>First Order Only</span><strong>{selectedOffer.isFirstOrderOnly ? 'Yes' : 'No'}</strong></div>}
                    {selectedOffer.showDiscountOnProductPage !== undefined && <div><span>Show on Product Page</span><strong>{selectedOffer.showDiscountOnProductPage ? 'Yes' : 'No'}</strong></div>}
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button className="vendors-modal-close" onClick={handleCloseDetailsModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Existing Modal for Push to Supplier */}
          <Modal show={showModal} onHide={handleCloseModal} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>Selected Offers</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
                <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Offer ID</th>
                        <th>Offer Title</th>
                        <th>Product Vendor Name</th>
                        <th>Offer Code</th>
                        <th>Discount Value</th>
                        <th>Applicable Products</th>
                        <th>Status</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedItems.map((_id) => {
                        const selectedItem = data.find((item) => item._id === _id);
                        return (
                          <tr key={_id}>
                            <td>{selectedItem.offerId}</td>
                            <td>{selectedItem.offerTitle}</td>
                            <td>{selectedItem.productVendorName}</td>
                            <td>{selectedItem.offerCode}</td>
                            <td>{selectedItem.discountValue}</td>
                            <td>
                              {Array.isArray(selectedItem.applicableProducts)
                                ? selectedItem.applicableProducts.join(', ')
                                : selectedItem.applicableProducts}
                            </td>
                            <td>{selectedItem.isActive ? 'Active' : 'Inactive'}</td>
                            <td>{formatDate(selectedItem.startDate)}</td>
                            <td>{formatDate(selectedItem.endDate)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <h6>Choose the Vendors</h6>
                <div className="d-flex align-items-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      className="btn bg-light"
                      style={{ backgroundColor: 'white', color: 'black', border: '1px solid gray', width: '250px' }}
                    >
                      {selectedVendors.length > 0 ? `${selectedVendors.length} selected` : 'Select Vendors'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ paddingLeft: '30px' }}>
                      <Form.Check
                        type="checkbox"
                        label="vendor1"
                        checked={selectedVendors.includes('vendor1')}
                        onChange={() => handleSelect('vendor1')}
                      />
                      <Form.Check
                        type="checkbox"
                        label="vendor2"
                        checked={selectedVendors.includes('vendor2')}
                        onChange={() => handleSelect('vendor2')}
                      />
                      <Form.Check
                        type="checkbox"
                        label="vendor3"
                        checked={selectedVendors.includes('vendor3')}
                        onChange={() => handleSelect('vendor3')}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                  <div
                    style={{
                      backgroundColor: '#1EA073',
                      borderRadius: '5px',
                      padding: '8px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      marginLeft: '5px',
                    }}
                  >
                    <img src={eye} alt="View" style={{ width: '20px', height: '20px' }} />
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
              <Button variant="primary" onClick={handleCloseModal}>
                Confirm Push
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="vendors-footer">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ViewOffers;